declare namespace $ {

	type $mol_locale_select__dictionary_bog_ainews_app_settings_1 = $mol_type_enforce<
		({ 
			'ru': string,
			'en': string,
			'de': string,
		}) 
		,
		ReturnType< $mol_locale_select['dictionary'] >
	>
	type $mol_labeler__title_bog_ainews_app_settings_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_bog_ainews_app_settings_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_select__value_bog_ainews_app_settings_4 = $mol_type_enforce<
		ReturnType< $bog_ainews_app_settings['current_language_code'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__dictionary_bog_ainews_app_settings_5 = $mol_type_enforce<
		ReturnType< $bog_ainews_app_settings['langs_list'] >
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_labeler__title_bog_ainews_app_settings_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_bog_ainews_app_settings_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_check_box__title_bog_ainews_app_settings_8 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_bog_ainews_app_settings_9 = $mol_type_enforce<
		ReturnType< $bog_ainews_app_settings['is_enable_auto_translate'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_labeler__title_bog_ainews_app_settings_10 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_bog_ainews_app_settings_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_number__value_bog_ainews_app_settings_12 = $mol_type_enforce<
		ReturnType< $bog_ainews_app_settings['description_count_limiter_value'] >
		,
		ReturnType< $mol_number['value'] >
	>
	type $mol_number__precision_change_bog_ainews_app_settings_13 = $mol_type_enforce<
		number
		,
		ReturnType< $mol_number['precision_change'] >
	>
	type $mol_number__value_min_bog_ainews_app_settings_14 = $mol_type_enforce<
		number
		,
		ReturnType< $mol_number['value_min'] >
	>
	type $mol_labeler__title_bog_ainews_app_settings_15 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_bog_ainews_app_settings_16 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_check_box__title_bog_ainews_app_settings_17 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_bog_ainews_app_settings_18 = $mol_type_enforce<
		ReturnType< $bog_ainews_app_settings['auto_open_spoiler_check_box_value'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_check_box__title_bog_ainews_app_settings_19 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_bog_ainews_app_settings_20 = $mol_type_enforce<
		ReturnType< $bog_ainews_app_settings['open_links_in_new_tabs_check_box_value'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_list__rows_bog_ainews_app_settings_21 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_labeler__title_bog_ainews_app_settings_22 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_bog_ainews_app_settings_23 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_button_major__title_bog_ainews_app_settings_24 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_bog_ainews_app_settings_25 = $mol_type_enforce<
		ReturnType< $bog_ainews_app_settings['install'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_labeler__title_bog_ainews_app_settings_26 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_bog_ainews_app_settings_27 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	export class $bog_ainews_app_settings extends $bog_ainews_app_page {
		Interface_language_select( ): $mol_locale_select
		Interface_language_labeler( ): $mol_labeler
		current_language_code( next?: string ): string
		Translate_to_select( ): $mol_select
		Translate_to_labeler( ): $mol_labeler
		is_enable_auto_translate( next?: boolean ): boolean
		Auto_translate( ): $mol_check_box
		Localization_labeler( ): $mol_labeler
		description_count_limiter_value( next?: number ): number
		Description_count_limiter( ): $mol_number
		Description_count_limiter_labeler( ): $mol_labeler
		auto_open_spoiler_check_box_value( next?: boolean ): boolean
		Auto_open_spoiler_check_box( ): $mol_check_box
		open_links_in_new_tabs_check_box_value( next?: boolean ): boolean
		Open_links_in_new_tabs_check_box( ): $mol_check_box
		Spoilers_labeler_list( ): $mol_list
		Spoilers_labeler( ): $mol_labeler
		Install_button( ): $mol_button_major
		Install_labeler( ): $mol_labeler
		current_language( ): string
		langs_list( ): ({ 
			'ru': string,
			'en': string,
			'de': string,
		}) 
		title( ): string
		Logo( ): $mol_icon_settings
		install( next?: any ): any
		install_ios_instruction( ): string
		install_chrome_instruction( ): string
		install_edge_instruction( ): string
		install_unsupported_browser( ): string
		install_already_installed( ): string
		body( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=settings.view.tree.d.ts.map